const styles = () => ({
  uploadedPhoto: {
    maxWidth: 300,
    maxHeight: 250,
  },
  dropzoneText: {
    padding: "0 24px",
    color: "#A3A3A3",
  },
});

export default styles;
